import type { MantineThemeOverride } from '@mantine/core';
import Badge from './components/Badge';
import Button from './components/Button';
import Card from './components/Card';
import NumberInput from './components/NumberInput';
import Select from './components/Select';
import Textarea from './components/Textarea';
import TextInput from './components/TextInput';
import { createGetTheme } from './getTheme';
import colors from './mantine.colors';

export const defaultTheme: MantineThemeOverride = {
	fontFamily: 'Inter, sans-serif',
	white: '#fff',
	black: '#000',
	primaryColor: 'primary',
	colors: colors as unknown as MantineThemeOverride['colors'],
	components: {
		Badge,
		Button,
		Card,
		NumberInput,
		Select,
		Textarea,
		TextInput
	}
};

export const getTheme = createGetTheme(defaultTheme);

export default defaultTheme;
